import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import { combineStrings } from 'assets/utils/data/String';
import { useClaimJobEdit } from './ClaimEdit.Job.Hooks';

export default function ClaimEditJobClone() {
  const { lang } = getLocales();
  const { claimJob, product, claim, cloneApi, setAction } = useClaimJobEdit();

  return (
    <Confirm
      data={claimJob}
      onConfirm={({ id }) => cloneApi.execute({ id })}
      onClose={() => {
        setAction(undefined);
      }}
      actionName={lang.clone + ' ' + lang.claimJob}
      itemName={combineStrings('-', product?.category?.code, claim?.id?.toString(), `J${claimJob?.jobNumber}`)}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
